import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=51464434&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=51464434&prod&scoped=true&lang=css"
import style1 from "./TemplateEditor.vue?vue&type=style&index=1&id=51464434&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51464434",
  null
  
)

export default component.exports